import { render, staticRenderFns } from "./AnswerOptionsSm.vue?vue&type=template&id=64ec34ac"
import script from "./AnswerOptionsSm.vue?vue&type=script&lang=js"
export * from "./AnswerOptionsSm.vue?vue&type=script&lang=js"
import style0 from "./AnswerOptionsSm.vue?vue&type=style&index=0&id=64ec34ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports